import {
    fetchBackofficeInsurances,
    alterBackofficeInsurances,
    getEntityGroupsDropdown,
    getInstances,
} from "../../api/backoffice";

import Vue from "vue";
import i18n from "@/i18n";

const hasInvalidValue = (v) => {
    if (v?.type === "dropdown") {
        let invalidValue = true;
        v.options?.map((option) => {
            if (option.selected) {
                invalidValue = option?.value == null || v.value === "-1";
            }
        });
        return invalidValue;
    }

    return v.value == null || v.value === "";
};


const getDefaultState = () => {
    return {
        // ******* Backoffice insurances details *************
        insurancesBkoForm: {},
        insurancesDetails: {},
        containsChanges: false,
        // ******* Backoffice insurances site list *************
        backofficeInsurances: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            status: "S",
            filter_search: "",
        },
        dropdownsFilters: {
            statusList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "Ativo",
                selected: true,
            }, {
                value: 0,
                text: "Inativo",
            }]
        },
        isTableLoading: false,
        insurancesDetailsDropdown: {
            entityGroupList: [],
            instanceList: [],
        }
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice insurances details *************
    getInsurancesBkoForm: (state) => state.insurancesBkoForm,
    getInsurancesDetails: (state) => state.insurancesDetails,

    getContainsChanges: (state) => state.containsChanges,
    // ******* Backoffice insurances list *************
    getBackofficeInsurances: (state) => state.backofficeInsurances,
    getInsurancesTotalPages: (state) => state.totalPages,
    getInsurancesTotalResults: (state) => state.totalResults,
    getInsurancesFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getInsurancesFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    isTableLoading: (state) => state.isTableLoading,
    getEntityGroupList: (state) => state.insurancesDetailsDropdown.entityGroupList,
    getInstanceList: (state) => state.insurancesDetailsDropdown.instanceList,
};

const mutations = {
    // ******* Backoffice insurances details *************
    setInsurancesBkoForm(state, insurancesBkoForm) {
        state.insurancesBkoForm = insurancesBkoForm;
    },
    setInsurancesDetails(state, insurancesDetails) {
        state.insurancesDetails = insurancesDetails;
    },
    setFieldValue(state, { key, value, options }) {
        console.log(options);

        state?.insurancesBkoForm?.form?.forEach((form) => {
            let field = form.fields.find((f) => f.key === key);

            if (field && value && field.type !== "dropdown") {
                field.value = value;

                field.hasError = false;
            }
            if (field && value && field.type === "dropdown") {
                field.hasError = false;
            }
        });
    },
    setIncrementField(state, { key }) {
        state?.insurancesBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setFieldAttribute(state, { key, attribute, value }) {

        state?.insurancesBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);

            if (field) {
                if (!(field.key?.startsWith("idFinancial") || field.key?.startsWith("idGscCompany"))) {
                    var dropdownNeoObj = value.map((item) => {
                        return { value: item["id"], text: item["name"] };
                    });

                    dropdownNeoObj = [
                        {
                            value: -1,
                            text: i18n.t("dropdownSelection"),
                            disabled: true,
                        },
                        ...dropdownNeoObj,
                    ];
                    field[attribute] = dropdownNeoObj;
                } else {
                    field[attribute] = value;
                }

            }
        });
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    },
    // ******* Backoffice insurances list *************
    setBackofficeInsurances(state, backofficeInsurances) {
        backofficeInsurances = backofficeInsurances.map((insurance) => {
            return {
                ...insurance,
                disabled: true,
                hasError: false
            }
        });
        state.backofficeInsurances = backofficeInsurances;
    },
    setInsurancesTable(state, backofficeInsurances) {
        state.backofficeInsurances = backofficeInsurances;
    },
    setInsurancesTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setInsurancesTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setInsurancesFilters(state, insurancesFilters) {
        state.filters = insurancesFilters;
    },
    setMixedDropdownValues(
        state,
        {
            data,
            stateType = "dropdownsFilters",
            type,
            valueKey = "ID",
        }
    ) {
        var dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
    setEntityGroupSimpleList(state, { data, stateType, type }) {
        state[stateType][type] = data;
    },
    setEntityGroupList(state, entityGroupList) {
        state.insurancesDetails.entityGroupList = entityGroupList;
    },
    setInstanceSimpleList(state, { data, stateType, type }) {
        state[stateType][type] = data;
    }
};

const actions = {
    async checkIfFormIsValid({ commit }) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.insurancesBkoForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", { field: i18n.t(label) })}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    // ******* Backoffice insurances list *************
    async getBackofficeInsurances({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeInsurances(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeInsurances", response?.data?.data);
            commit("setInsurancesTotalPages", response?.data?.pages);
            commit("setInsurancesTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async alterBackofficeInsurances({ commit }, payload) {
        commit("setTableLoading", true);
        try {
            await alterBackofficeInsurances(payload.operation, payload.payload);
        } catch (error) {
            console.log(error);
        }   finally {
            commit("setTableLoading", false);
        }
    },
    async getEntityGroupList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityGroupsDropdown(idInstance);
            const entityGroups = response?.data?.data;

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "insurancesDetailsDropdown",
                type: "entityGroupList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getInstanceList({ commit }) {
        try {
            const response = await getInstances();
            const instances = response?.data?.data;

            commit("setInstanceSimpleList", {
                data: instances,
                stateType: "insurancesDetailsDropdown",
                type: "instanceList",
            });
        } catch (error) {
            console.log(error)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
